import React from "react";

const TitleHeader = ({title, titleBold, subtitle}) => (
  <div className="titleHeader">
    <div className="titleHeader__title">
      {title} <span className="titleHeader__title__bold">{titleBold}</span>
    </div>
    <div className="titleHeader__subtitle">{subtitle}</div>
  </div>
);

export default TitleHeader;